export function getCampaignStatus(startDate: string, endDate: string): 'upcoming' | 'active' | 'completed' {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (now < start) return 'upcoming';
    if (now > end) return 'completed';
    return 'active';
}

export function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
 return date.toLocaleDateString('en-US', {
    month: 'short',
        day: 'numeric',
   year: 'numeric'
    });
}

export function formatDateShort(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric'
    });
}

export function formatBudget(amount: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
  }).format(amount);
}

export function getDayOfYear(date: Date): number {
 const start = new Date(date.getFullYear(), 0, 0);
    const diff = date.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
}

export function getTotalDaysInYear(year: number): number {
    return (new Date(year, 11, 31).getTime() - new Date(year, 0, 0).getTime()) / (1000 * 60 * 60 * 24);
}

export function getCurrentDatePosition(): number {
    const now = new Date();
    const year = now.getFullYear();
    const startOfYear = new Date(year, 0, 1);
    const endOfYear = new Date(year, 11, 31, 23, 59, 59, 999);
    const total = endOfYear.getTime() - startOfYear.getTime();
    const elapsed = now.getTime() - startOfYear.getTime();
    return Math.min(100, Math.max(0, (elapsed / total) * 100));
}

export function splitCampaignByYear(
    campaign: { startDate: string; endDate: string },
    year: number
): { startMonth: number; endMonth: number } | null {
    const start = new Date(campaign.startDate);
    const end = new Date(campaign.endDate);
    if (start.getFullYear() > year || end.getFullYear() < year) return null;
    const startMonth = start.getFullYear() === year ? start.getMonth() + 1 : 1;
    const endMonth = end.getFullYear() === year ? end.getMonth() + 1 : 12;
    if (startMonth > endMonth) return null;
    return { startMonth, endMonth };
}
